import React, {useEffect} from 'react';
import TextField from '../../../components/TextField/TextField';
import CustomButton from '../../../components/Button/Button';
import {useTranslation} from 'react-i18next';
import {useFormik} from 'formik';
import {AAListFilters, useStyles} from './FiltersComponent.utils';

interface Filters {
    page: number;
    pageSize: number;
    handleSearch: (
        params?: { pageSize: number; page: number },
        filters?: AAListFilters,
    ) => void;
    handleForceFirstPage?: () => void;
    triggerSearch?: boolean;
}

const FiltersComponent: React.VFC<Filters> = ({
    page,
    pageSize,
    handleSearch,
    handleForceFirstPage,
    triggerSearch,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const {
        values,
        handleChange,
        handleSubmit,
    } = useFormik<AAListFilters>({
        initialValues: {
            extensionFilter: '',
            idFilter: '',
            didNumberFilter: '',
        },
        onSubmit: (form) => {
            handleSearch({ page: 0, pageSize }, form);
            handleForceFirstPage?.();
        },
    });

    useEffect(() => {
        console.log('in filters')

        handleSearch({ page, pageSize }, values);
    }, [page, pageSize]);

    useEffect(() => {
        triggerSearch && handleSearch({ page, pageSize }, values);
    }, [triggerSearch]);

    return (
        <form
            className={classes.filtersContainer}
            onSubmit={handleSubmit}
            data-qa={'auto-attendants-list-filters'}
            data-testid={'auto-attendants-list-filters'}
        >
            <div className={classes.filtersInputs}>
                <TextField
                    id={'extensionFilter'}
                    className={classes.filterSeparation}
                    label={t('common:name')}
                    value={values.extensionFilter}
                    onChange={handleChange}
                    dataQa={'filter-by-extension'}
                />
                <TextField
                    id={'didNumberFilter'}
                    className={classes.filterSeparation}
                    label={t('screens:extensions.didNumber')}
                    value={values.didNumberFilter}
                    onChange={handleChange}
                    dataQa={'filter-by-didNumber'}
                />
                <TextField
                    id={'idFilter'}
                    className={classes.filterSeparation}
                    label={t('screens:billing.accountID')}
                    value={values.idFilter}
                    onChange={handleChange}
                    dataQa={'filter-by-account-id'}
                />
            </div>
            <CustomButton dataQa="search-button" primary accent type="submit">
                {t('common:search')}
            </CustomButton>
        </form>
    );
};

export default FiltersComponent;
